module.exports = __webpack_public_path__ + "img/le_grand_bleu.0fc4f4ad.jpg";